import React from 'react';
import withScript from '../../withScript';
import { buttonScriptSources } from '../consts';
import { PaypalMessageBase } from './paypalMessageBase';

const PaypalPayLayerLearnMore = (props) => <PaypalMessageBase {...props} />;

export default withScript(buttonScriptSources)(PaypalPayLayerLearnMore);
